import axios from 'axios';
import apis from '@/services/links_apis.js'

export const stations = {

    namespaced: true,

    state: {
        hydrometereologicalStations: [],
        nonTelemetricMeteorologicalStations: [],
        accelerographicStations: [],
        phreatrimeticStations: [],
        airqualityStations: []
    },

    actions: {
        async Get_Hydrometereological_Stations({ commit }){
            try{
                const RESPONSE = await axios.post(apis.stations_typology+'hydrometeorological');
                commit('Set_Hydrometereological_Stations',RESPONSE.data);
            }catch(e){
                console.log(e);
            }
        },

        async Get_Non_Telemetric_Metereological_Stations({ commit }){
            try{
                const RESPONSE = await axios.post(apis.stations_typology+'nonTelemetricMeteorological');
                commit('Set_Non_Hydrometereological_Stations',RESPONSE.data);
            }catch(e){
                console.log(e);
            }
        },

        async Get_Accelerographic_Stations({ commit }){
            try{
                const RESPONSE = await axios.post(apis.stations_typology+'accelerograph');
                commit('Set_Accelerographic_Stations',RESPONSE.data);
            }catch(e){
                console.log(e);
            }
        },

        async Get_Phreatrimetric_Stations({ commit }){
            try{
                const RESPONSE = await axios.post(apis.stations_typology+'phreatrimetric');
                commit('Set_Phreatrimetric_Stations',RESPONSE.data);
            }catch(e){
                console.log(e);
            }
        },

        async Get_Airquality_Stations({ commit }){
            try{
                const RESPONSE = await axios.post(apis.stations_typology+'airQuality');
                commit('Set_Airquality_Stations',RESPONSE.data);
            }catch(e){
                console.log(e);
            }
        }
    },

    mutations:{

        Set_Hydrometereological_Stations: (state,hidro) => state.hydrometereologicalStations = hidro,

        Set_Non_Hydrometereological_Stations: (state,nontele) => state.nonTelemetricMeteorologicalStations = nontele,

        Set_Accelerographic_Stations: (state,accele) => state.accelerographicStations = accele,

        Set_Phreatrimetric_Stations: (state,phrea) => state.phreatrimeticStations = phrea,

        Set_Airquality_Stations: (state,airq) => state.airqualityStations = airq

    }
};
